import { useState } from 'react'
import MainHeader from '../../../ReusableComponents/Header/MainHeader'
import PrgmSelection from '../../../ReusableComponents/PrgmSlider/PrgmSelection/PrgmSelection'
import ZingPrgmSelection from '../../../ReusableComponents/PrgmSlider/ZingPrgmSelection/ZingPrgmSelection'
import { useHistory } from 'react-router'
import renderPrgImage from '../../../../source/programImg'
import { connect } from 'react-redux'

const MENU_OPTIONS = [
    {
        name: 'Move',
        imgSrc: 'moveOpen',
        link: '/code/project/action/select',
        imgStyle: { width: '19rem' },
    },
    {
        name: 'Music',
        imgSrc: 'musicOpen',
        link: '/code/project/action/create',
        imgStyle: { width: '19rem' },
    },
]

const container = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '22rem',
    width: '100vw',
    // paddingTop: '180px',
    position: 'absolute',
    top: '46%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
}

const menuText = {
    // position: 'relative',
    position: 'absolute',
    // top: '-8.5rem',
    top: '9.5rem',
    left: '4rem',
    fontSize: '1.3rem',
    cursor: 'pointer',
    width: '50%',
}

function SelectActionType(props) {
    const history = useHistory()
    let connectedDevice = sessionStorage.getItem('connectedDevice')
    const [slideDirection, setSlideDirection] = useState(
        sessionStorage.getItem('slideDirection')
    )

    const sendTorque0 = () => {
        if (props.webSerial.isConnected) {
            props.worker.postMessage({
                type: 'writeArray',
                value: ['S'.charCodeAt(0), 'R'.charCodeAt(0), 0],
            })
        }
    }

    return (
        <div>
            <MainHeader
                help_btnPosition="right"
                // helper={
                //     ['Humanoid', 'Hexapod'].includes(connectedDevice) ? (
                //         <div
                //             className="PS-S_slide"
                //             style={{
                //                 left: '70%',
                //                 transform: 'translate(-50%)',
                //             }}
                //         >
                //             <ZingPrgmSelection />
                //         </div>
                //     ) : (
                //         <div
                //             className="PS-S_slide"
                //             style={{
                //                 left: '70%',
                //                 transform: 'translate(-50%)',
                //             }}
                //         >
                //             <PrgmSelection />
                //         </div>
                //     )
                // }
                goBack={() => {
                    setSlideDirection(true)
                    sessionStorage.setItem('slideDirection', true)
                    history.push('/code/project')
                }}
                isGoBack={true}
            />
            <div
                style={{
                    height: '100vh',
                    position: 'relative',
                    // border: '1px solid red',
                }}
            >
                {' '}
                <div style={container}>
                    {MENU_OPTIONS &&
                        MENU_OPTIONS.map((option, index) => (
                            <div
                                key={index}
                                style={{
                                    width: '19rem',
                                    height: '15rem',
                                    //   opacity: 0.3,
                                    position: 'relative',
                                }}
                            >
                                <>
                                    <img
                                        alt=""
                                        src={renderPrgImage(option.imgSrc)}
                                        style={{
                                            ...option.imgStyle,
                                            opacity: '1',
                                        }}
                                    />
                                    <p
                                        onClick={() => {
                                            sessionStorage.setItem(
                                                'isSave',
                                                JSON.stringify(true)
                                            )
                                            history.push(option.link)
                                            if (option.name === 'Music') {
                                                sessionStorage.setItem(
                                                    'isShowNewUI',
                                                    'true'
                                                )
                                                sendTorque0()
                                            } else {
                                                sessionStorage.setItem(
                                                    'isShowNewUI',
                                                    'false'
                                                )
                                            }
                                        }}
                                        style={{
                                            ...menuText,
                                            opacity: '1',
                                            whiteSpace: 'pre-line',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {option.name}
                                    </p>
                                    <div
                                        style={{
                                            width: '50%',
                                            height: '54%',
                                            position: 'relative',
                                            top: '-16rem',
                                            left: '5rem',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => {
                                            sessionStorage.setItem(
                                                'isSave',
                                                JSON.stringify(true)
                                            )
                                            history.push(option.link)
                                            if (option.name === 'Music') {
                                                sessionStorage.setItem(
                                                    'isShowNewUI',
                                                    'true'
                                                )
                                                sendTorque0()
                                            } else {
                                                sessionStorage.setItem(
                                                    'isShowNewUI',
                                                    'false'
                                                )
                                            }
                                        }}
                                    ></div>
                                </>
                            </div>
                        ))}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return state
}
export default connect(mapStateToProps)(SelectActionType)
